<template>
	<div class="scroll-frame" ref="frame">
		<div v-if="$slots.head" class="scroll-frame-head"><slot name="head"></slot></div>
		<div class="scroll-frame-body"><slot></slot></div>
		<div v-if="$slots.tail" class="scroll-frame-tail"><slot name="tail"></slot></div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";

//const props = defineProps<{}>();
const frame = ref<HTMLDivElement | null>(null);
defineExpose({
	frame
});
</script>

<style>
.scroll-frame {
}
</style>